export { default } from './ChipAttributes';
